/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PutTournamentsIdAnnounceMutationResponse,
  PutTournamentsIdAnnouncePathParams,
} from "../types/PutTournamentsIdAnnounce.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const putTournamentsIdAnnounceMutationKey = () =>
  [{ url: "/tournaments/:id/announce" }] as const;

export type PutTournamentsIdAnnounceMutationKey = ReturnType<
  typeof putTournamentsIdAnnounceMutationKey
>;

/**
 * @summary Анонсировать турнир (изменить статус с Upcoming на RegistrationOpen)
 * {@link /tournaments/:id/announce}
 */
export async function putTournamentsIdAnnounce(
  id: PutTournamentsIdAnnouncePathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PutTournamentsIdAnnounceMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "PUT", url: `/tournaments/${id}/announce`, ...requestConfig });
  return res;
}

export function putTournamentsIdAnnounceMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = putTournamentsIdAnnounceMutationKey();
  return mutationOptions<
    ResponseConfig<PutTournamentsIdAnnounceMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: PutTournamentsIdAnnouncePathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return putTournamentsIdAnnounce(id, config);
    },
  });
}

/**
 * @summary Анонсировать турнир (изменить статус с Upcoming на RegistrationOpen)
 * {@link /tournaments/:id/announce}
 */
export function usePutTournamentsIdAnnounce<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PutTournamentsIdAnnounceMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: PutTournamentsIdAnnouncePathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putTournamentsIdAnnounceMutationKey();

  const baseOptions = putTournamentsIdAnnounceMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PutTournamentsIdAnnounceMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: PutTournamentsIdAnnouncePathParams["id"] },
    TContext
  >;

  return useMutation<
    ResponseConfig<PutTournamentsIdAnnounceMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: PutTournamentsIdAnnouncePathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PutTournamentsIdAnnounceMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: PutTournamentsIdAnnouncePathParams["id"] },
    TContext
  >;
}
